import React, { Component } from 'react';
import { roomTypeColumn, roomTypeTableData } from './RoomTypeTableData';
import DataTable from '../../../../../Common/DataTable/DataTable';
import DataTableHeader from '../../../../../Common/DataTableHeader/DataTableHeader';
import DataTableFooter from '../../../../../Common/DataTableFooter/DataTableFooter';

const RoomTypeTable = ({ data, loading, onEdit, onDelete }) => {
  if (loading) return <p>Loading Room Type...</p>;

  if (!data.length) return <p>No Room Type found.</p>;

  const dataT = data.map((data, index) => {
    return {
      roomTypeId: index + 1,
      roomTypeName: data.name,
      actions: (
        <>
          <button
            type="button"
            className="btn"
            data-bs-toggle="modal"
            data-bs-target="#edit-roomType"
            onClick={() => onEdit(data)}
          >
            <i className="bi bi-pencil-square"></i>
          </button>
          <button
            type="button"
            onClick={() => onDelete(data.id)}
            className="btn deleterow"
          >
            <i className="bi bi-trash text-danger"></i>
          </button>
        </>
      ),
    };
  });

  return (
    <>
      <DataTableHeader />
      <DataTable columns={roomTypeColumn} data={dataT} />
      <DataTableFooter dataT={dataT} />
    </>
  );
};


export default RoomTypeTable;
